var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LoggerService } from './logger.service';
import { environment } from '../../../environments/environment-wrapper';
var BrowserLoggerService = /** @class */ (function (_super) {
    __extends(BrowserLoggerService, _super);
    function BrowserLoggerService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserLoggerService.prototype.isEnabled = function (category, level) {
        if (level === 'dbug' || (environment.production && category === 'missingTranslation')) {
            return false;
        }
        switch (category) {
            default:
                return true;
        }
    };
    return BrowserLoggerService;
}(LoggerService));
export { BrowserLoggerService };
